import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NbToastrService} from '@nebular/theme';
import {ApiService} from '../../../@core/service/api.service';
import {Subscription} from 'rxjs';
import {MaterialModel} from '../../../@models';
import {
  FormListBusinessUnitRendererComponent,
} from '../../shared/form-list/renderer/form-list-business-unit-renderer.component';
import { AuthGuardService } from '../../../@core/service/auth-guard.service';
import { FormListComponent } from '../../shared';
import { SharedDataService } from '../../../@core/service/shared-data.service';
import { waitForVariable } from '../../../@core/common/global';

@Component({
    selector: 'ngx-erp-material',
    templateUrl: './material.component.html',
    styleUrls: ['./material.component.scss']
})

export class MaterialComponent implements OnInit {

  @ViewChild('formList') formList: FormListComponent;
  
  // materials: MaterialModel[];

  materialColumns: any;

  // source: LocalDataSource;
  // subscription: Subscription;

  constructor(
    private api: ApiService,
    public data: SharedDataService,
    private auth: AuthGuardService,
    private toastrService: NbToastrService,
  ) { }

  ngOnInit() {
    // this.source = new LocalDataSource([]);
    // this.subscription = this.api.reloadMaterials().subscribe(values => {
    //   // this.source.load(values);
    //   this.materials = values;
    // });

    this.data.loadMaterials().then(async (m) => await waitForVariable(this.api, 'formList') && this.formList.reload(m));

    this.data.loadBusinessUnits().then(bus => {
      const buList = bus.map(x => ({title: x.name, value: x._id}));
      this.materialColumns = {

        businessUnit: {
          title: 'BU',
          type: 'custom',
          renderComponent: FormListBusinessUnitRendererComponent,
          editor: {
            type: 'list',
            config: {
              selectText: 'Select',
              list: buList,
            },
          },
          filter: true,
          filterFunction: (el, query) => ((bus.find(f => f._id === el) || {})['name'] || '').indexOf(query) >= 0,
          sort: true,
          compareFunction: (dir, a, b) => {
            const aa = (bus.find(f => f._id === a) || {})['name'] || '';
            const bb = (bus.find(f => f._id === b) || {})['name'] || '';
            return aa.toLowerCase() > bb.toLowerCase() ? dir: -dir;
          },
        },
        name: {
          title: 'Name',
          type: 'text',
          filter: true,
          sort: true,
        },
        description: {
          title: 'Description',
          type: 'text',
          editor: {
            type: 'textarea',
          },
          filter: true,
          sort: true,
        },
        code: {
          title: 'Code',
          type: 'text',
          filter: true,
          sort: true,
          addable: false,
          editable: false,
        },
      };
    });
  }

  validate(event) {
    if (this.auth.user.erpRoles.readOnlyMaterials) {
      event.confirm.reject('No acces rights');
      this.toastrService.danger('You don\'t have rights to modify materials', 'Error');
    } else if (event.newData.name === '') {
      event.confirm.reject('Name is required');
      this.toastrService.danger('Name is required', 'Error');
    } else if (event.newData.businessUnit === null) {
      event.confirm.reject('Business Unit is required');
      this.toastrService.danger('Business Unit is required', 'Error');
    } else {
      const sub = this.api.saveMaterial(event.newData).subscribe(s => {
        this.data.reloadMaterials();
        sub.unsubscribe();
      });
      event.confirm.resolve();
    }
  }
}
